/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Detail_Exactly_How_The_Ai_ShouInputs */

const en_detail_exactly_how_the_ai_shou = /** @type {(inputs: Detail_Exactly_How_The_Ai_ShouInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Detail exactly how the AI should present your brand, which features to emphasize, and how to handle high-value inquiries...`)
};

const es_detail_exactly_how_the_ai_shou = /** @type {(inputs: Detail_Exactly_How_The_Ai_ShouInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Detalla exactamente cómo la IA debe presentar tu marca, qué características enfatizar y cómo manejar las consultas de alto valor...`)
};

const fr_detail_exactly_how_the_ai_shou = /** @type {(inputs: Detail_Exactly_How_The_Ai_ShouInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Détaillez exactement comment l'IA doit présenter votre marque, quelles fonctionnalités souligner et comment gérer les demandes de grande valeur...`)
};

const de_detail_exactly_how_the_ai_shou = /** @type {(inputs: Detail_Exactly_How_The_Ai_ShouInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Detailliere genau, wie die KI deine Marke präsentieren, welche Merkmale sie hervorheben und wie sie hochwertige Anfragen bearbeiten soll...`)
};

const ja_detail_exactly_how_the_ai_shou = /** @type {(inputs: Detail_Exactly_How_The_Ai_ShouInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`AIがあなたのブランドをどのように提示すべきか、どの機能を強調すべきか、価値の高い問い合わせにどう対応すべきかを正確に詳細に記述してください...`)
};

const zh_detail_exactly_how_the_ai_shou = /** @type {(inputs: Detail_Exactly_How_The_Ai_ShouInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`准确描述 AI 应该如何展示您的品牌，强调哪些特点，以及如何处理高价值的咨询...`)
};

const ar_detail_exactly_how_the_ai_shou = /** @type {(inputs: Detail_Exactly_How_The_Ai_ShouInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`اشرح بالضبط كيف يجب أن يقدم الذكاء الاصطناعي علامتك التجارية، وأي الميزات يجب التركيز عليها، وكيفية التعامل مع الاستفسارات عالية القيمة...`)
};

const id_detail_exactly_how_the_ai_shou = /** @type {(inputs: Detail_Exactly_How_The_Ai_ShouInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Perinci dengan tepat bagaimana AI harus mempresentasikan merek Anda, fitur mana yang ditekankan, dan bagaimana menangani pertanyaan bernilai tinggi...`)
};

const it_detail_exactly_how_the_ai_shou = /** @type {(inputs: Detail_Exactly_How_The_Ai_ShouInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dettaglia esattamente come l'IA dovrebbe presentare il tuo brand, quali caratteristiche enfatizzare e come gestire le richieste di alto valore...`)
};

const ru_detail_exactly_how_the_ai_shou = /** @type {(inputs: Detail_Exactly_How_The_Ai_ShouInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Точно опишите, как ИИ должен представлять ваш бренд, какие функции подчеркивать и как обрабатывать дорогостоящие запросы...`)
};

const pt_detail_exactly_how_the_ai_shou = /** @type {(inputs: Detail_Exactly_How_The_Ai_ShouInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Detalhe exatamente como a IA deve apresentar a sua marca, quais recursos enfatizar e como lidar com consultas de alto valor...`)
};

const ko_detail_exactly_how_the_ai_shou = /** @type {(inputs: Detail_Exactly_How_The_Ai_ShouInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`AI가 귀하의 브랜드를 어떻게 제시하고, 어떤 특징을 강조하며, 고가 문의를 어떻게 처리해야 하는지 정확히 자세히 설명해 주세요...`)
};

/**
* | output |
* | --- |
* | "Detail exactly how the AI should present your brand, which features to emphasize, and how to handle high-value inquiries..." |
*
* @param {Detail_Exactly_How_The_Ai_ShouInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const detail_exactly_how_the_ai_shou = /** @type {((inputs?: Detail_Exactly_How_The_Ai_ShouInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Detail_Exactly_How_The_Ai_ShouInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_detail_exactly_how_the_ai_shou(inputs)
	if (locale === "es") return es_detail_exactly_how_the_ai_shou(inputs)
	if (locale === "fr") return fr_detail_exactly_how_the_ai_shou(inputs)
	if (locale === "de") return de_detail_exactly_how_the_ai_shou(inputs)
	if (locale === "ja") return ja_detail_exactly_how_the_ai_shou(inputs)
	if (locale === "zh") return zh_detail_exactly_how_the_ai_shou(inputs)
	if (locale === "ar") return ar_detail_exactly_how_the_ai_shou(inputs)
	if (locale === "id") return id_detail_exactly_how_the_ai_shou(inputs)
	if (locale === "it") return it_detail_exactly_how_the_ai_shou(inputs)
	if (locale === "ru") return ru_detail_exactly_how_the_ai_shou(inputs)
	if (locale === "pt") return pt_detail_exactly_how_the_ai_shou(inputs)
	return ko_detail_exactly_how_the_ai_shou(inputs)
});